export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";